import { ensureCsrfToken, getCsrfTokenFromCookie, refreshAccessToken } from './authApi';
import { readErrorMessage, readResponseBody } from '../utils/apiResponse';

const MUTATING_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

let authState = {
  getAccessToken: () => null,
  setAccessToken: () => {},
  clearSession: () => {},
};

export const configureHttpClient = ({ getAccessToken, setAccessToken, clearSession }) => {
  authState = { getAccessToken, setAccessToken, clearSession };
};

const buildHeaders = async (method, headers = {}) => {
  const nextHeaders = {
    'Content-Type': 'application/json',
    ...headers,
  };

  const accessToken = authState.getAccessToken();
  if (accessToken) {
    nextHeaders.Authorization = `Bearer ${accessToken}`;
  }

  if (MUTATING_METHODS.has(method)) {
    await ensureCsrfToken();
    const csrfToken = getCsrfTokenFromCookie();
    if (csrfToken) {
      nextHeaders['X-XSRF-TOKEN'] = csrfToken;
    }
  }

  return nextHeaders;
};

export const apiRequest = async (url, options = {}, retried = false) => {
  const method = (options.method || 'GET').toUpperCase();
  const headers = await buildHeaders(method, options.headers);

  let response;
  try {
    response = await fetch(url, {
      ...options,
      method,
      credentials: 'include',
      headers,
    });
  } catch {
    throw new Error('서버에 연결할 수 없습니다. 네트워크 상태를 확인해 주세요.');
  }

  if (response.status === 401 && !retried) {
    const newToken = await refreshAccessToken();
    if (newToken) {
      authState.setAccessToken(newToken);
      return apiRequest(url, options, true);
    }

    authState.clearSession();
  }

  if (!response.ok) {
    throw new Error(await readErrorMessage(response));
  }

  return readResponseBody(response);
};
